import { Component, ViewEncapsulation, OnInit, ViewChild, LOCALE_ID, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1501Model } from './kymw1501.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetMarkFileRequestModel } from './vo/get-mark-file-request.model';
import { DatePipe } from '@angular/common';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';

/**
 * マーク検索条件設定画面を管理するクラス
 *
 * @export KYMW1501Component
 * @class KYMW1501Component
 */
@Component({
  selector: 'app-kymw1501',
  templateUrl: 'kymw1501.component.html',
  styleUrls: ['kymw1501.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1501Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtf_RegistMarkDateFrom', { static: true }) public dtf_RegistMarkDateFrom: WjInputDate;
  @ViewChild('dtf_RegistMarkDateTo', { static: true }) public dtf_RegistMarkDateTo: WjInputDate;
  @ViewChild('dtf_FileRegistDateFrom', { static: true }) public dtf_FileRegistDateFrom: WjInputDate;
  @ViewChild('dtf_FileRegistDateTo', { static: true }) public dtf_FileRegistDateTo: WjInputDate;

  kymw1501Model: KYMW1501Model = new KYMW1501Model();

  // 親画面への連携用 
  setKYMW1501Parameter: Function;

  isComposing = false;

  /**
   *Creates an instance of KYMW1501Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1501Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1501Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1501';
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {GetMarkFileRequestModel} iVo
   * @param {Array<any>} markGroupList
   * @param {Array<any>} supplyPromoteMarkDivList
   * @memberof KYMW1501Component
   */
  public setInterfaceParam(iVo: GetMarkFileRequestModel): void {
    // 画面表示時保持用
    this.kymw1501Model.kymw1501InputVO = iVo;
    // 入力値格納用
    this.kymw1501Model.markFileName = iVo.MarkFileName;
    this.kymw1501Model.markName = iVo.MarkName;
    this.kymw1501Model.markGroupCode = iVo.MarkGroupCode;
    this.kymw1501Model.supplyPromoteMarkDiv = iVo.SupplyPromoteMarkDiv;
    this.kymw1501Model.unableOnly = iVo.UnableOnly;
    this.kymw1501Model.fileNonRegistOnly = iVo.FileNonRegistOnly;
    this.kymw1501Model.registMarkDateFrom = PlessViewUtilsSub.editDate(iVo.RegistMarkDateFrom, '2');
    this.kymw1501Model.registMarkDateTo = PlessViewUtilsSub.editDate(iVo.RegistMarkDateTo, '2');
    this.kymw1501Model.fileRegistDateFrom = PlessViewUtilsSub.editDate(iVo.FileRegistDateFrom, '2');
    this.kymw1501Model.fileRegistDateTo = PlessViewUtilsSub.editDate(iVo.FileRegistDateTo, '2');
  }

  /**
   * ボタン「検索」クリックイベント
   *
   * @private
   * @returns {void}
   * @memberof KYMW1501Component
   */
  public eventGetMarkFile_CLICKHandler(): void {
    /* 元の画面のバインド変数に値をセット */
    this.kymw1501Model.kymw1501InputVO.MarkName = this.kymw1501Model.markName;
    this.kymw1501Model.kymw1501InputVO.MarkFileName = this.kymw1501Model.markFileName;
    this.kymw1501Model.kymw1501InputVO.MarkGroupCode = this.kymw1501Model.markGroupCode;
    this.kymw1501Model.kymw1501InputVO.SupplyPromoteMarkDiv = this.kymw1501Model.supplyPromoteMarkDiv;
    this.kymw1501Model.kymw1501InputVO.FileNonRegistOnly = this.kymw1501Model.fileNonRegistOnly;
    this.kymw1501Model.kymw1501InputVO.UnableOnly = this.kymw1501Model.unableOnly;
    // 元の画面は文字列型で保持しているため日付は文字列yyyyMMddの文字列に変換
    this.kymw1501Model.kymw1501InputVO.RegistMarkDateFrom = PlessViewUtilsSub.editDate(this.dtf_RegistMarkDateFrom.text, '1');
    this.kymw1501Model.kymw1501InputVO.RegistMarkDateTo = PlessViewUtilsSub.editDate(this.dtf_RegistMarkDateTo.text, '1');
    this.kymw1501Model.kymw1501InputVO.FileRegistDateFrom = PlessViewUtilsSub.editDate(this.dtf_FileRegistDateFrom.text, '1');
    this.kymw1501Model.kymw1501InputVO.FileRegistDateTo = PlessViewUtilsSub.editDate(this.dtf_FileRegistDateTo.text, '1');

    // 入力チェック
    if (!this.inputCheckGetMarkFile(this.kymw1501Model.kymw1501InputVO)) {
      return;
    }

    // 処理を実行
    this.setKYMW1501Parameter(this.kymw1501Model.kymw1501InputVO);

    // 正常終了時はマーク検索画面を閉じる
    super.onClickClose();
  }

  /**
   * ボタン「クリア」（マーク名登録日）クリックイベントリスナ
   */
  public eventRegistMarkDateClear_CLICKHandler(): void {
    this.kymw1501Model.registMarkDateFrom = '';
    this.kymw1501Model.registMarkDateTo = '';
  }

  /**
   * ボタン「クリア」（マーク名登録日）クリックイベントリスナ
   */
  public eventFileRegistDateClear_CLICKHandler(): void {
    this.kymw1501Model.fileRegistDateFrom = '';
    this.kymw1501Model.fileRegistDateTo = '';
  }

  /**
   * 適用期間指定の入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheckGetMarkFile(vo: GetMarkFileRequestModel): boolean {
    // 「マーク名登録日」チェック（From 、及び TO の両方が指定された場合のみ）
    if (this.isToDateOverFromDate(vo.RegistMarkDateFrom, vo.RegistMarkDateTo, 'マーク名登録日')) {
      return false;
    }
    // 「マークファイル登録日」チェック（From 、及び TO の両方が指定された場合のみ）
    if (this.isToDateOverFromDate(vo.FileRegistDateFrom, vo.FileRegistDateTo, 'マークファイル登録日')) {
      return false;
    }
    return true;
  }

  /**
   * 日付のToがFromよりも後を指定しているかチェック
   *
   * @private
   * @param {*} from From日付
   * @param {*} to To日付
   * @param {*} itemName エラーメッセージに表示する項目名
   * @returns true: ToがFromより後を指定　false:ToがFromより前を指定
   * @memberof KYMW1501Component
   */
  private isToDateOverFromDate(from: string, to: string, itemName: string): boolean {
      // 「マークファイル登録日」チェック（From 、及び TO の両方が指定された場合のみ）
      if ((!PlessViewUtilsSub.isEmpty(from)) && (!PlessViewUtilsSub.isEmpty(to))) {
        if (Number(from) > Number(to)) {
          this.dialogService.openAlertGetMessage('E0123', [itemName]);
          return true;
        }
      }
    return false;
  }

  /**
   * マークファイル名の入力から半角カンマを削除
   */
  public eventMarkFileName_deleteCommaHandler(): void {
    this.kymw1501Model.markFileName = this.kymw1501Model.markFileName.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
